export const API_URL="https://afdprojipacpre7000.azurefd.net";
export const SSO_URL = "https://apis-pre.groupe-atlantic.com:443";
export const ENV="release";
export const VERSION="0.0.1";
export const LOGOUT_REDIRECT_URL="wso2creator_ATL_Projipac4_Pre_PRODUCTION";
